var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgMap = function SvgMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 2c16.569 0 30 13.431 30 30 0 16.568-13.431 30-30 30C15.431 62 2 48.568 2 32 2 15.43 15.431 2 32 2z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.1 22.597l-6.426-1.816a.186.186 0 00-.103 0l-4.693 1.368a.183.183 0 01-.106 0l-4.545-1.36a.175.175 0 00-.103-.002L20.58 22.62a.193.193 0 00-.136.145l-4.44 20.656c-.03.145.103.27.242.226l8.523-2.663a.184.184 0 01.114 0l6.999 2.239a.187.187 0 00.116-.001l6.917-2.31a.186.186 0 01.114-.001l8.591 2.663a.191.191 0 00.241-.227L43.233 22.74a.192.192 0 00-.134-.144zM27.114 20.75l-2.281 20.162M36.699 20.847l2.252 20.251M31.824 22.242l.109 21.258"
  })))));
};
export default SvgMap;